
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../grpc"

import {
    Permission,
} from "../../base/organization/permission"

import {
    OrganizationContext,
} from "../../base/access_context"

export interface GetCosStsCredential4LogoResponse {
    bucketUrl?: string
    bucket?: string
    region?: string
    key?: string
    sessionToken?: string
    tmpSecretId?: string
    tmpSecretKey?: string
    expirationTime?: number
}

export interface GetCosStsCredential4LogoRequest {
    filename?: string /* 将要上传的logo文件名，eg：aa.jpg */
}

export interface ListAccountsByOrganizationIdsAndAccountGroupNameResponse {
    organizationAccountGroupAccountList: Array<OrganizationAccountGroupAccount>
}

export interface OrganizationAccountGroupAccount {
    organization: Organization
    accountGroupAccountList: Array<AccountGroupAccount>
}

export interface ListAccountsByOrganizationIdsAndAccountGroupNameRequest {
    organizationIdList: Array<number>
    accountGroupNameList: Array<string>
}

export interface GetOrganizationByOrganizationGroupIdResponse {
    organization: Organization
}

export interface GetOrganizationByOrganizationGroupIdRequest {
    organizationGroupId?: number
}

export interface NewGetAccountGroupAccountsByOrganizationIdsRequest {
    organizationIds: Array<number>
}

export interface NewGetAccountGroupAccountsByOrganizationIdsResponse {
    accountGroupAccount: Array<AccountGroupAccount>
}

export interface AccountGroupAccount {
    organizationId: number
    accountId: Array<number>
}

export interface AddAccountToAccountGroupByAccountIdRequest {
    accountId: number
    accountGroupId: number
}

export interface AddAccountToAccountGroupByAccountIdResponse {
    done: boolean
}

export interface GetAccountGroupAccountsByOrganizationIdsRequest {
    organizationIds: Array<number>
}

export interface GetAccountGroupAccountsByOrganizationIdsResponse {
    accountIds: Array<number>
}

export interface GetAccountByOrganizationIdRequest {
    organizationId: number
}

export interface GetAccountByOrganizationIdResponse {
    accountId: number
}

export interface CreateOrganizationGroupRequest {
    createOrganizationGroup: CreateOrganizationGroup
}

export interface CreateOrganizationGroupResponse {
    organizationGroupId: number
}

export interface GetOrganizationByNameAndTypeRequest {
    name: string
    type: string
}

export interface GetOrganizationByNameAndTypeResponse {
    organization: Organization
}

export interface UpdateOrganizationNameAndDescriptionRequest {
    organizationId?: number
    name?: string
    description?: string
    organizationLogo?: string
}

export interface UpdateOrganizationNameAndDescriptionResponse {
    isUpdated: boolean
}

export interface UpdateOrganizationGroupNameAndDescriptionRequest {
    organizationGroupId?: number
    name?: string
    description?: string
}

export interface UpdateOrganizationGroupNameAndDescriptionResponse {
    isUpdated: boolean
}

export interface CreateOrganizationRelationshipRequest {
    organizationId?: number
    invatationOrganizationId?: number
}

export interface CreateOrganizationRelationshipResponse {
    organizationRelationshipId: number
}

export interface DeleteOrganizationRelationshipRequest {
    organizationRelationshipId: number
}

export interface DeleteOrganizationRelationshipResponse {
    isDeleted: boolean
}

export interface AlterDefaultOrganizationRelationshipRequest {
    organizationRelationshipId: number
    invatationOrganizationId: number
}

export interface AlterDefaultOrganizationRelationshipResponse {
    isAlter: boolean
}

export interface OrganizationRelationshipResult {
    organizationId?: number
    invatationOrganizationId?: number
    isDefault?: boolean
    id?: number
}

export interface GetOrganizationRelationshipByIdRequest {
    organizationRelationshipId: number
}

export interface GetOrganizationRelationshipByIdResponse {
    organizationRelationshipResult: OrganizationRelationshipResult
}

export interface GetOrganizationRelationshipListByOrganizationIdRequest {
    organizationId: number
}

export interface GetOrganizationRelationshipListByOrganizationIdResponse {
    organizationRelationshipResults: Array<OrganizationRelationshipResult>
}

export interface GetDefaultOrganizationRelationshipRequest {
    organizationId: number
}

export interface GetDefaultOrganizationRelationshipResponse {
    organizationRelationshipResult: OrganizationRelationshipResult
}

export interface GetAccountGroupPermissionUUIDsRequest {
    organizationAccountGroups: Array<OrganizationAccountGroup>
}

export interface OrganizationAccountGroup {
    organizationId: number
    accountGroupId: number
}

export interface GetAccountGroupPermissionUUIDsResponse {
    permissionUUIDs: string
}

export interface GetAccountGroupByAccountIdRequest {
    accountId?: number
}

export interface GetAccountGroupByAccountIdResponse {
    accountGroup: Array<OrganizationAccountGroup>
}

export interface DeleteAccountGroupPermissionResponse {
    success?: boolean
}

export interface DeleteAccountGroupPermissionRequest {
    organizationId?: number
    accountGroupId?: number
    uuiDs: Array<string>
}

export interface ListAccountGroupPermissionUUIDResponse {
    permissionUUIDs: string
}

export interface ListAccountGroupPermissionUUIDRequest {
    organizationId?: number
    accountGroupId?: number
}

export interface ListAccountGroupPermissionResponse {
    accountGroupPermission: AccountGroupPermission
}

export interface AccountGroupPermission {
    organizationId?: number
    accountGroupId?: number
    permission: Array<Permission>
}

export interface ListAccountGroupPermissionRequest {
    organizationId?: number
    accountGroupId?: number
}

export interface AuthorizeToAccountGroupResponse {
    success?: boolean
}

export interface AuthorizeToAccountGroupRequest {
    organizationId?: number
    accountGroupId?: number
    permissionUUIDs: Array<string>
}

export interface GetOrganizationByIdsRequest {
    ids: Array<number>
}

export interface GetOrganizationByIdsResponse {
    organizations: Array<Organization>
}

export interface GetOrganizationsByTypeRequest {
    type: string
}

export interface GetOrganizationsByTypeResponse {
    organizations: Array<Organization>
}

export interface GetOrganizationOrganizationsRequest {
    organizationId: number
}

export interface GetOrganizationOrganizationsResponse {
    organizationGroups: Array<OrganizationGroupInfo>
}

export interface GetOrganizationParentOrganizationGroupRequest {
    organizationId: number
}

export interface GetOrganizationParentOrganizationGroupResponse {
    organizationGroup: OrganizationGroup
}

export interface UpdateOrganizationsOrganizationGroupRequest {
    organizationIds: Array<number>
    organizationGroupId: number
}

export interface UpdateOrganizationsOrganizationGroupResponse {
    done: boolean
}

export interface GetOrganizationsByOrganizationGroupIdsRequest {
    organizationGroupIds: Array<number>
}

export interface GetOrganizationsByOrganizationGroupIdsResponse {
    organizationGroupList: Array<OrganizationGroupList>
}

export interface Organization {
    name: string
    description: string
    id: number
    type?: string
    organizationLogo?: string
    creationTimestamp?: number
    parentOrganizationGroupId?: number
}

export interface GetOrganizationGroupsByOrganizationIdRequest {
    organizationId: number
}

export interface GetOrganizationGroupsByOrganizationIdResponse {
    organizationGroups: Array<OrganizationGroup>
}

export interface OrganizationGroup {
    id: number
    name: string
    description: string
}

export interface GetAccountGroupContextRequest {
}

export interface GetAccountGroupContextResponse {
    accountGroups: Array<AccountGroupContext>
}

export interface AccountGroupContext {
    id: number
    name: string
    description: string
    organizationId: number
}

export interface GetOrganizationContextRequest {
    type: OrganizationType
}

export interface GetOrganizationContextResponse {
    organizationContext: Array<OrganizationContext>
}

export interface GetAccountPermissionRequest {
    accountId: number
}

export interface GetAccountPermissionResponse {
    organizationContext: Array<OrganizationContext>
}

export interface AcceptUserInvitationRequest {
    uuid: string
}

export interface AcceptUserInvitationResponse {
    isAccepted: boolean
}

export interface GetUserGroupInvitationUuidRequest {
    organizationId: number
    accountGroupId: number
    count: number
}

export interface GetUserGroupInvitationUuidResponse {
    uuid: string
}

export interface GetAccountGroupRequest {
    organizationId: number
}

export interface GetAccountGroupResponse {
    accountGroup: Array<AccountGroup>
}

export interface AccountGroup {
    id: number
    name: string /* 名称，用于查询，尽量使用英文 */
    displayName: string /* 昵称，用于显示 */
    description: string
}

export interface GetAccountGroupAccountRequest {
    organizationId: number
    name: string
}

export interface GetAccountGroupAccountResponse {
    organizationAccountId: Array<number>
}

export interface RemoveAccountFromAccountGroupRequest {
    accountGroupId: number
    accountId: number
}

export interface RemoveAccountFromAccountGroupResponse {
    isRemoved: boolean
}

export interface AddAccountToAccountGroupRequest {
    accountGroupId: number
}

export interface AddAccountToAccountGroupResponse {
    isAdded: boolean
}

/*todo 是否需要删除下面的组员 */
export interface DeletedAccountGroupRequest {
}

export interface DeletedAccountGroupResponse {
}

export interface CreateAccountGroupRequest {
    createAccountGroup: CreateAccountGroup
}

export interface CreateAccountGroup {
    organizationId: number
    name: string /* 名称，用于查询，尽量使用英文 */
    displayName: string /* 昵称，用于显示 */
    description: string
}

export interface CreateAccountGroupResponse {
    accountGroupId: number
}

export interface CreateOrganizationGroup {
    parentOrganizationId: number
    name: string
    description: string
}

export interface DeleteOrganizationRequest {
    organizationId: number
}

export interface DeleteOrganizationResponse {
    isDeleted: boolean
}

export interface CreateOrganizationRequest {
    createOrganization: CreateOrganization
}

export interface CreateOrganizationResponse {
    organizationId: number
}

export interface CreateOrganization {
    organizationGroupId?: number
    name: string
    description: string
    type?: string
    organizationLogo?: string
}

export interface CheckOrganizationRequest {
    /* 组织id */
    organizationId: number
}

export interface CheckOrganizationResponse {
    status: boolean
}

export interface AccountGroupAccount {
    accountGroup: AccountGroup
    accountIdList: Array<number>
}

export interface OrganizationAccountGroup {
    organizationId: number
    accountGroupIds: Array<number>
}

export interface OrganizationGroupInfo {
    organizationGroupId: number
    name: string
    description: string
    organizations: Array<OrganizationInfo>
}

export interface OrganizationInfo {
    organizationId: number
    name: string
    description: string
    organizationGroups: Array<OrganizationGroupInfo>
}

export interface OrganizationGroupList {
    organizationGroupId: number
    organizationList: Array<Organization>
}

export enum OrganizationType {
    EULER = 0,
    STUDIO = 1,
}

/* 组织关系 */
export class OrganizationService extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /* region organization
 创建「组织组」 */
    async createOrganizationGroup(request: CreateOrganizationGroupRequest): Promise<CreateOrganizationGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/CreateOrganizationGroup"
        return await this.call(method, path, request) as CreateOrganizationGroupResponse
    }
    
    /* 创建「组织」 */
    async createOrganization(request: CreateOrganizationRequest): Promise<CreateOrganizationResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/CreateOrganization"
        return await this.call(method, path, request) as CreateOrganizationResponse
    }
    
    /* 确认「组织」是否存在 */
    async checkOrganization(request: CheckOrganizationRequest): Promise<CheckOrganizationResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/CheckOrganization"
        return await this.call(method, path, request) as CheckOrganizationResponse
    }
    
    /* 查看「组织」下的所有「组织组」 */
    async getOrganizationGroupsByOrganizationId(request: GetOrganizationGroupsByOrganizationIdRequest): Promise<GetOrganizationGroupsByOrganizationIdResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationGroupsByOrganizationId"
        return await this.call(method, path, request) as GetOrganizationGroupsByOrganizationIdResponse
    }
    
    /* 查看「组织组」下的所有「组织」 */
    async getOrganizationsByOrganizationGroupIds(request: GetOrganizationsByOrganizationGroupIdsRequest): Promise<GetOrganizationsByOrganizationGroupIdsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationsByOrganizationGroupIds"
        return await this.call(method, path, request) as GetOrganizationsByOrganizationGroupIdsResponse
    }
    
    /* 修改「组织」的「组织组」 */
    async updateOrganizationsOrganizationGroup(request: UpdateOrganizationsOrganizationGroupRequest): Promise<UpdateOrganizationsOrganizationGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/UpdateOrganizationsOrganizationGroup"
        return await this.call(method, path, request) as UpdateOrganizationsOrganizationGroupResponse
    }
    
    /* 查看「组织」所属「组织组」 */
    async getOrganizationParentOrganizationGroup(request: GetOrganizationParentOrganizationGroupRequest): Promise<GetOrganizationParentOrganizationGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationParentOrganizationGroup"
        return await this.call(method, path, request) as GetOrganizationParentOrganizationGroupResponse
    }
    
    /* 查看「组织」下的所有「组织」 */
    async getOrganizationOrganizations(request: GetOrganizationOrganizationsRequest): Promise<GetOrganizationOrganizationsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationOrganizations"
        return await this.call(method, path, request) as GetOrganizationOrganizationsResponse
    }
    
    /* 查看「组织组」的「组织」信息 */
    async getOrganizationByOrganizationGroupId(request: GetOrganizationByOrganizationGroupIdRequest): Promise<GetOrganizationByOrganizationGroupIdResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationByOrganizationGroupId"
        return await this.call(method, path, request) as GetOrganizationByOrganizationGroupIdResponse
    }
    
    /* 批量根据「组织」id列表查看「组织」 */
    async getOrganizationByIds(request: GetOrganizationByIdsRequest): Promise<GetOrganizationByIdsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationByIds"
        return await this.call(method, path, request) as GetOrganizationByIdsResponse
    }
    
    /* 根据类型查看「组织」 */
    async getOrganizationsByType(request: GetOrganizationsByTypeRequest): Promise<GetOrganizationsByTypeResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationsByType"
        return await this.call(method, path, request) as GetOrganizationsByTypeResponse
    }
    
    /*修改「组织」名与描述 */
    async updateOrganizationNameAndDescription(request: UpdateOrganizationNameAndDescriptionRequest): Promise<UpdateOrganizationNameAndDescriptionResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/UpdateOrganizationNameAndDescription"
        return await this.call(method, path, request) as UpdateOrganizationNameAndDescriptionResponse
    }
    
    /*修改「组织组」名与描述 */
    async updateOrganizationGroupNameAndDescription(request: UpdateOrganizationGroupNameAndDescriptionRequest): Promise<UpdateOrganizationGroupNameAndDescriptionResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/UpdateOrganizationGroupNameAndDescription"
        return await this.call(method, path, request) as UpdateOrganizationGroupNameAndDescriptionResponse
    }
    
    /* 根据名称和类型获取「组织」 */
    async getOrganizationByNameAndType(request: GetOrganizationByNameAndTypeRequest): Promise<GetOrganizationByNameAndTypeResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationByNameAndType"
        return await this.call(method, path, request) as GetOrganizationByNameAndTypeResponse
    }
    
    
    /* 批量获取「组织」下的所有「用户」，返回accountID集合 */
    async getAccountGroupAccountsByOrganizationIds(request: GetAccountGroupAccountsByOrganizationIdsRequest): Promise<GetAccountGroupAccountsByOrganizationIdsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetAccountGroupAccountsByOrganizationIds"
        return await this.call(method, path, request) as GetAccountGroupAccountsByOrganizationIdsResponse
    }
    
    /* 新 获取「组织」下的所有「用户」，返回「organizationID、accountID」集合 */
    async newGetAccountGroupAccountsByOrganizationIds(request: NewGetAccountGroupAccountsByOrganizationIdsRequest): Promise<NewGetAccountGroupAccountsByOrganizationIdsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/NewGetAccountGroupAccountsByOrganizationIds"
        return await this.call(method, path, request) as NewGetAccountGroupAccountsByOrganizationIdsResponse
    }
    
    /* 批量获取指定用户组成员根据「组织列表、用户组名」 */
    async listAccountsByOrganizationIdsAndAccountGroupName(request: ListAccountsByOrganizationIdsAndAccountGroupNameRequest): Promise<ListAccountsByOrganizationIdsAndAccountGroupNameResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/ListAccountsByOrganizationIdsAndAccountGroupName"
        return await this.call(method, path, request) as ListAccountsByOrganizationIdsAndAccountGroupNameResponse
    }
    
    /* 删除组织 */
    async deleteOrganization(request: DeleteOrganizationRequest): Promise<DeleteOrganizationResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/DeleteOrganization"
        return await this.call(method, path, request) as DeleteOrganizationResponse
    }
    
    /* 根据组织类型获取OrganizationContext */
    async getOrganizationContext(request: GetOrganizationContextRequest): Promise<GetOrganizationContextResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationContext"
        return await this.call(method, path, request) as GetOrganizationContextResponse
    }
    
    /* region account group
 创建用户组 */
    async createAccountGroup(request: CreateAccountGroupRequest): Promise<CreateAccountGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/CreateAccountGroup"
        return await this.call(method, path, request) as CreateAccountGroupResponse
    }
    
    /* 获取用户组 */
    async getAccountGroup(request: GetAccountGroupRequest): Promise<GetAccountGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetAccountGroup"
        return await this.call(method, path, request) as GetAccountGroupResponse
    }
    
    /* 组织组新增用户（根据accountID） */
    async addAccountToAccountGroupByAccountId(request: AddAccountToAccountGroupByAccountIdRequest): Promise<AddAccountToAccountGroupByAccountIdResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/AddAccountToAccountGroupByAccountId"
        return await this.call(method, path, request) as AddAccountToAccountGroupByAccountIdResponse
    }
    
    /* 用户自己加入用户组（用户登陆后传accessToken） */
    async addAccountToAccountGroup(request: AddAccountToAccountGroupRequest): Promise<AddAccountToAccountGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/AddAccountToAccountGroup"
        return await this.call(method, path, request) as AddAccountToAccountGroupResponse
    }
    
    
    
    /* 获取用户组成员 */
    async getAccountGroupAccount(request: GetAccountGroupAccountRequest): Promise<GetAccountGroupAccountResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetAccountGroupAccount"
        return await this.call(method, path, request) as GetAccountGroupAccountResponse
    }
    
    /* 用户组织移除用户 */
    async removeAccountFromAccountGroup(request: RemoveAccountFromAccountGroupRequest): Promise<RemoveAccountFromAccountGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/RemoveAccountFromAccountGroup"
        return await this.call(method, path, request) as RemoveAccountFromAccountGroupResponse
    }
    
    async getAccountGroupContext(request: GetAccountGroupContextRequest): Promise<GetAccountGroupContextResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetAccountGroupContext"
        return await this.call(method, path, request) as GetAccountGroupContextResponse
    }
    
    /* 获取添加用户uuid */
    async getUserGroupInvitationUuid(request: GetUserGroupInvitationUuidRequest): Promise<GetUserGroupInvitationUuidResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetUserGroupInvitationUuid"
        return await this.call(method, path, request) as GetUserGroupInvitationUuidResponse
    }
    
    /* 用户组添加用户（uuid） */
    async acceptUserInvitation(request: AcceptUserInvitationRequest): Promise<AcceptUserInvitationResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/AcceptUserInvitation"
        return await this.call(method, path, request) as AcceptUserInvitationResponse
    }
    
    
    /* 给用户组授权 */
    async authorizeToAccountGroup(request: AuthorizeToAccountGroupRequest): Promise<AuthorizeToAccountGroupResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/AuthorizeToAccountGroup"
        return await this.call(method, path, request) as AuthorizeToAccountGroupResponse
    }
    
    /* 获取用户组权限 */
    async listAccountGroupPermission(request: ListAccountGroupPermissionRequest): Promise<ListAccountGroupPermissionResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/ListAccountGroupPermission"
        return await this.call(method, path, request) as ListAccountGroupPermissionResponse
    }
    
    /* 获取组织用户组权限UUIDs（鉴权用） */
    async listAccountGroupPermissionUUID(request: ListAccountGroupPermissionUUIDRequest): Promise<ListAccountGroupPermissionUUIDResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/ListAccountGroupPermissionUUID"
        return await this.call(method, path, request) as ListAccountGroupPermissionUUIDResponse
    }
    
    /* 删除组织用户组权限 */
    async deleteAccountGroupPermission(request: DeleteAccountGroupPermissionRequest): Promise<DeleteAccountGroupPermissionResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/DeleteAccountGroupPermission"
        return await this.call(method, path, request) as DeleteAccountGroupPermissionResponse
    }
    
    /* 根据用户组id获取权限uuid集合 */
    async getAccountGroupPermissionUUIDs(request: GetAccountGroupPermissionUUIDsRequest): Promise<GetAccountGroupPermissionUUIDsResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetAccountGroupPermissionUUIDs"
        return await this.call(method, path, request) as GetAccountGroupPermissionUUIDsResponse
    }
    
    /* region organization relationship
 创建组织关系 */
    async createOrganizationRelationship(request: CreateOrganizationRelationshipRequest): Promise<CreateOrganizationRelationshipResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/CreateOrganizationRelationship"
        return await this.call(method, path, request) as CreateOrganizationRelationshipResponse
    }
    
    /* 删除组织关系 */
    async deleteOrganizationRelationship(request: DeleteOrganizationRelationshipRequest): Promise<DeleteOrganizationRelationshipResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/DeleteOrganizationRelationship"
        return await this.call(method, path, request) as DeleteOrganizationRelationshipResponse
    }
    
    /* 切换默认组织关系 */
    async alterDefaultOrganizationRelationship(request: AlterDefaultOrganizationRelationshipRequest): Promise<AlterDefaultOrganizationRelationshipResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/AlterDefaultOrganizationRelationship"
        return await this.call(method, path, request) as AlterDefaultOrganizationRelationshipResponse
    }
    
    /* 通过id获取组织关系 */
    async getOrganizationRelationshipById(request: GetOrganizationRelationshipByIdRequest): Promise<GetOrganizationRelationshipByIdResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationRelationshipById"
        return await this.call(method, path, request) as GetOrganizationRelationshipByIdResponse
    }
    
    /* 通过organizationId获取组织关系列表 */
    async getOrganizationRelationshipListByOrganizationId(request: GetOrganizationRelationshipListByOrganizationIdRequest): Promise<GetOrganizationRelationshipListByOrganizationIdResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetOrganizationRelationshipListByOrganizationId"
        return await this.call(method, path, request) as GetOrganizationRelationshipListByOrganizationIdResponse
    }
    
    /* 通过organizationId获取默认组织关系 */
    async getDefaultOrganizationRelationship(request: GetDefaultOrganizationRelationshipRequest): Promise<GetDefaultOrganizationRelationshipResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetDefaultOrganizationRelationship"
        return await this.call(method, path, request) as GetDefaultOrganizationRelationshipResponse
    }
    
    /* 获取上传组织logo的cos临时密钥 */
    async getCosStsCredential4Logo(request: GetCosStsCredential4LogoRequest): Promise<GetCosStsCredential4LogoResponse> {
        const method = "post"
        const path = "/base.organization.OrganizationService/GetCosStsCredential4Logo"
        return await this.call(method, path, request) as GetCosStsCredential4LogoResponse
    }
    
}
